import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { openBulkCancelModal } from '../../../store/orders/edit-order/edit.order.actions';
import { useOneOrMoreOrderSelectedDisabled } from '../disabled-hooks/use-one-or-more-order-selected-disabled';
import { messages } from './messages';

export const usePendingFulfillmentCancelOrder = () => {
  const dispatch = useDispatch();
  const oneOrMoreOrderSelectedDisabled = useOneOrMoreOrderSelectedDisabled();

  const actionHandler = useCallback(() => {
    const shouldShowPendingFulfillmentText = true;
    dispatch(openBulkCancelModal(shouldShowPendingFulfillmentText));
  }, [dispatch]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsFulfillmentCancelOrder,
      isDisabled: oneOrMoreOrderSelectedDisabled,
      disabledReason: null,
    };
  }, [actionHandler, oneOrMoreOrderSelectedDisabled]);
};
